import DefaultModal from '@/components/Modals/DefaultModal'
import ConfirmCancelModalFooter from '@/components/Modals/ConfirmCancelModalFooter'
import { Flex } from '@/components/Flex'
import { Headline2, InfoLabel, Label } from '@/components/Typography'
import { useModal } from '@/hooks/useModal'
import { DefaultModalProp } from '@/typings/Modals'
import { useRebootNode } from '../application/hooks/useRebootNode'
import { useServerDetails } from '../application/hooks/useServerDetails'

export default function RebootNodeModal({
  setOpen,
  ...props
}: DefaultModalProp) {
  const modal = useModal('rebootNode')
  const serverId = modal.data.serverId

  const { data: server } = useServerDetails(serverId)
  const rebootMutation = useRebootNode()

  const isControlPlane = server?.nodeType === 'control_plane'

  const onConfirm = () => {
    rebootMutation.mutate(serverId, {
      onSuccess: () => modal.close(),
    })
  }

  return (
    <DefaultModal
      {...props}
      setOpen={setOpen}
      type="rebootNode"
      modalHeader={<Headline2>Reboot Node</Headline2>}
      modalBody={
        <Flex flexDirection="column" width="100%" mt="1rem" gap="0.75rem">
          <Label>
            Reboot {server ? server.name : 'this node'}? It boots into the config
            that is already on its disk, including a patch that was delivered but
            is not active yet.
          </Label>
          {isControlPlane && (
            <Label color="orange">
              This is a control plane node. Nothing is cordoned or drained first,
              and rebooting it takes an etcd member out of the quorum — on a
              three-node control plane, two nodes down at once stop the cluster.
            </Label>
          )}
          <InfoLabel>
            Beam only asks the node to reboot; it does not watch it come back.
            The node keeps reading &ldquo;Awaiting reboot&rdquo; here even once
            it has rebooted.
          </InfoLabel>
        </Flex>
      }
      modalFooter={ConfirmCancelModalFooter}
      isLoading={rebootMutation.isPending}
      onConfirm={onConfirm}
      confirmButtonText="Reboot"
      cancelButtonText="Cancel"
    />
  )
}
